module.exports = {
    'Detail': {
        'SetupForm': function () {
            console.log('Legacy Resources SetupForm called');
        }
    }
};